angular.module('rjmNg.controllers').controller('DashWrapperCtrl', [
  "$scope"
  "$rootScope"
  "$routeParams"
  "Charts"
  "Clients"
  "MagentoStores"
  "Trend"
  "GoogleAnalytics"
  "$q"
  "dashboardService"
  "userEventService"
  "$modal"
  "Journal"
  "DashboardItem"
  "$window"
  "$url"
  "app"
  "notification"
  "$timeout"
  "dashboardItemLoadQueue"
  "figureService"
  "figureEnums"
  "$location"
  "overdueBillingModalService"
  "freeTrialBillingModalService"
  "reportQueryType"
  "utils"
  "FEATURE_TIER"
  "appRoute"
  "MOBILE_WIDTH"
  "rjpopover"
  "rjpopoverGroupNames"
  "DashboardDividers"
  "dashboardConstants"
  "Figures"
  (
    $scope
    $rootScope
    $routeParams
    Charts
    Clients
    MagentoStores
    Trend
    GoogleAnalytics
    $q
    dashboardService
    userEventService
    $modal
    Journal
    DashboardItem
    $window
    $url
    app
    notification
    $timeout
    dashboardItemLoadQueue
    figureService
    figureEnums
    $location
    overdueBillingModalService
    freeTrialBillingModalService
    reportQueryType
    utils
    FEATURE_TIER
    appRoute
    MOBILE_WIDTH
    rjpopover
    rjpopoverGroupNames
    DashboardDividers
    dashboardConstants
    Figures
  ) ->

    $scope.RJPOPOVER_GROUP_NAME = rjpopoverGroupNames.DASHBOARDS
    $scope.DIVIDER_TYPES = dashboardConstants.DIVIDER_TYPES
    $scope.usesRjqlService = app.getRjqlVersion() >= 1.0  # 1.0 == MBI 3.0

    $scope.isEnabled = false
    $scope.isGroupStoreMapFeature = false
    $scope.groupName = ""
    $scope.storeIds = []
    $scope.stores = []
    ALL_STORES = "All Stores"



    $scope.isMobile = () ->
      $window.innerWidth <= MOBILE_WIDTH

    $scope.search =
      reportSearch: ""

    $scope.resetReportSearch = () ->
      $scope.search.reportSearch = ""

    # save dashboard items by making copies of them and removing the chart property
    # so we don't send crazy amounts of data to the server for no good reason
    _saveDashboardItems = ->
      DashboardItem.bulkUpdate(
        clientId: app.getClientId()
      ,
        $scope.dashboardItems
      )

    $scope.gridsterOpts =
      minRows: 5
      columns: 12
      colWidth: if $scope.isMobile() then $window.innerWidth/4.5 else "auto"
      rowHeight: 'match'
      margins: [5, 5]
      maxRows: 500
      isMobile: $scope.isMobile()
      mobileBreakPoint: MOBILE_WIDTH
      mobileModeEnabled: $scope.isMobile()
      resizable:
        enabled: true
        handles: ["se"]
        start: (event, $element, uiWidget) ->
          $scope.$broadcast 'hideChartsAndFigures'
        stop: (event, $element, uiWidget) ->
          scope = $element.data("$scope")
          $scope.$broadcast 'showChartsAndFigures'
          scope.$broadcast "resizeGridsterItemFigureElement"
          _saveDashboardItems()
          Journal.save
            type: "chart resize"
            key: scope.dashboardItem.id
            value: null
            meta:
              clientId: app.getClientId()
              dashboardId: +dashboardService.dashboard.id
              userId: app.getUserId()
              isSupportUser: app.isSupportUserSession()
              sizeX: scope.dashboardItem.sizeX
              sizeY: scope.dashboardItem.SizeY
          return false
      draggable:
        enabled: not $scope.isMobile()
        handle: ".rj-dashboard-item__title"
        start: (event, $element, uiWidget) ->
          $scope.$broadcast 'hideChartsAndFigures'
          rjpopover.hideGroup(rjpopoverGroupNames.DASHBOARDS)
        stop: (event, $element, uiWidget) ->
          $scope.$broadcast 'showChartsAndFigures'
          _saveDashboardItems()

    $scope.presentationTypeEnums = figureEnums.PRESENTATION_TYPES

    gridsterResizePromise = null
    gridsterResizedListener = $rootScope.$on 'gridster-resized', (sizes, gridster) ->
      if gridsterResizePromise?
        $timeout.cancel(gridsterResizePromise)

      gridsterResizePromise = $timeout ->
        $scope.$broadcast "resizeGridsterItemFigureElement"
        gridsterResizePromise = null
      , 500
      , false

    # this watches the dashboard item array's $resolved and length properties
    # if the new and old array resolved properties are both true we know the data has been loaded and is stable
    # if the new and old array lengths are the same then no dashboardItems have been added or removed.
    # All together if the data is loaded/stable and the lengths don't match trigger an dashboardItem update because
    # an item was added or removed from the array.
    $scope.$watch () ->
      resolved: $scope.dashboardItems.$resolved
      length: $scope.dashboardItems.length
    , (dashboardWatcher, old) ->
      if dashboardWatcher.resolved and
          old.resolved and
          dashboardWatcher.length isnt old.length
        $timeout -> # need to timeout to wait for the grid to settle and all items to update their data
          _saveDashboardItems()
    , true

    $scope.$watch ->
      return not $scope.canEditDashboard || $scope.isTouring
    , (gridDisable, old) ->
      $scope.gridsterOpts.resizable.enabled = not gridDisable
      $scope.gridsterOpts.draggable.enabled = not gridDisable

    # Only poll to load dashboard item charts/figs when on dashboard
    $rootScope.$on( "$routeChangeStart", ->
      dashboardRoutePattern = new RegExp(/^\/client\/\d*\/dashapp\/\d*\/?$/i)
      dashboardItemLoadQueue.observeRouteChange(dashboardRoutePattern.test($location.path()))
    )

    $scope.dynamicTooltipEvents = ["resizeGridsterItemFigureElement"]

    userHasRandomPassword = () ->
      user = $scope.app.getUser()
      user.randomPassword

    $scope.allowLegacyEdit = (dashboardItem) ->
      return dashboardItem.chartId and
        dashboardItem.chart? and
        app.getFeatureTier() is FEATURE_TIER.PREMIUM

    $scope.allowReportBuilderEdit = (dashboardItem) ->
      if dashboardItem.figure? and dashboardItem.figure.reportQueryType is reportQueryType.SQL
        return app.canAccessSqlReportBuilder()

      if figureService.isCohortFigure(dashboardItem.figure)
        return app.isCohortBuilderAllowed()

      if dashboardItem.figureId and not dashboardItem.chartId
        return true

      if dashboardItem.figureId
        return true

      return false

    #set active dashboard
    _setActive = (dashId) ->
      dashboard = app.getDashboard(+dashId)
      dashboardService.setWindowTitle(dashboard?.name + " - Adobe Commerce Intelligence")

      #ignore if this is the same dashboard (to avoid double setting the active dashboard)
      if dashboardService.dashboard?.id is +dashId
        return

      #log dashboard view
      if dashboard?
        dashboardService.setDashboard(dashboard)
      else
        notification.error("Dashboard Error", "Unable to find this dashboard. Please choose a dashboard from the list of available dashboards.", "global")

    _setActive($routeParams.dashId)


    $rootScope.$on "$routeChangeSuccess", (e, cur, prev) ->
      if $routeParams.dashId then _setActive($routeParams.dashId)

    # Utility functions

    $scope.addedToGridster = (dashboardItem) ->
      dashboardItem.row? and dashboardItem.column?

    $scope.isDashboardItemDivider = (dashboardItem) ->
      return dashboardItem.divider?

    _addNewDashboardItemsToGridster = (items) ->
      if $scope.isMobile()
        for item in items
          item.sizeX = 4
          item.sizeY = 4

      changed = for i in items when not $scope.addedToGridster(i)
        i.row = 0
        i.column = 0
      if changed.length > 0
        $timeout ->
          _saveDashboardItems()

    #load all dashbaordItems for the current dashboard
    _loadDashboardItems = ->

      if $scope.dashboard?
        $scope.dashboard.dashboardItems = DashboardItem.query
          clientId: app.getClientId()
          dashboardId: +$routeParams.dashId
        , (dashboardItems) =>

          _journalLog('new chrome dashboard load', +$routeParams.dashId, 1)
          $scope.isLoading = false
          
          if app.isAumEnabled()
            Clients.get($routeParams.clientId)
            .then ({properties}) ->
              {enable_store_dwf, feature_tier, is_group_store_access} = properties
              $scope.isEnabled = feature_tier is FEATURE_TIER.BASIC.toString() or enable_store_dwf is "1"
              $scope.isGroupStoreMapFeature = is_group_store_access is "1"
              if $scope.isEnabled
                MagentoStores($routeParams.clientId).getAll {}, ({data,group_access_name}) ->
                  if is_group_store_access
                    if group_access_name
                      $scope.groupName = group_access_name
                    else
                      $scope.groupName = 'default'
                  availableStores = data.body.map ([id, name]) ->
                    name = _.unescape name
                    $scope.storeIds.push(id)
                    {id, name}
                  availableStores.push
                    id: 0
                    name: ALL_STORES
                  $scope.stores = availableStores
                  if $scope.isGroupStoreMapFeature
                    storeFilter = [
                      field: "store_id"
                      operator: "IN"
                      value: $scope.storeIds
                    ]
                    dashboardService.extraDashboardFilters = storeFilter
                    dashboardItemLoadQueue.load(dashboardItems)
                  else
                    dashboardItemLoadQueue.load(dashboardItems)
              else
                dashboardItemLoadQueue.load(dashboardItems)
          else
            dashboardItemLoadQueue.load(dashboardItems)
          $timeout ->
            _addNewDashboardItemsToGridster dashboardItems

        , (error) ->
          $scope.isLoading = false
          unless utils.requestWasCanceled error
            notification.error("Dashboard Item Error", "Unable to load this dashboard.", "global")

        return $scope.dashboard.dashboardItems

      # if dashboard is null then this usually means that we couldn't find such a dashboard so just load it empty
      return []

    _logDashboardItemAction = (dItem, action) ->
      if dItem.figureId?
        _journalLog('Dashboard Figure Usage', dItem.figureId, 1, action)
      else
        _journalLog('new chrome chart add', dItem.chartId, 1, action)

    _journalLog = (type, key, value, action = null) ->
      Journal.save
        type: type
        key: key
        value: value
        meta:
          clientId: app.getClientId()
          userId: app.getUserId()
          isSupportUser: app.isSupportUserSession()
          isSyndicated: $scope.dashboard?.is_syndicated
          dashboardId: +$routeParams.dashId
          action: action

    _updateChartBuilderOptions = (chart) ->
      dashboardService.openChartBuilder()
      $scope.chartBuilderOptions.chart = chart
      $scope.chartBuilderOptions.dashId = $routeParams.dashId
      $scope.showGrid = false

    # end Utility functions

    #This is neccessary in order to correctly set the active dashboard when we switch dashboards through the nav bar
    #It seems silly that we need this even though we bind to the 'dashboardReady' event, but for some reason it doesnt work otherwise
    $scope.dashboard = dashboardService.dashboard

    # This event is triggered when adding a new chart/figure via the utilities bar
    $scope.$on "dashboardItemAdded", (event, dItem) ->
      #load the data
      dashboardItemLoadQueue.load([dItem])
      $scope.dashboardItems.push dItem
      _addNewDashboardItemsToGridster [dItem]
      #journal log for "add"
      _logDashboardItemAction(dItem, "add")

    $scope.trends = Trend.getMetalist(clientId: app.getClientId())

    # Load GA resources that will be used by Report Builder
    setTimeout () ->
      GoogleAnalytics.getDimensions(app.getClientId())
      GoogleAnalytics.getMetrics(app.getClientId())
    , 6000

    $scope.isLoading = true
    $scope.dashboardItems = _loadDashboardItems()
    $scope.canEditDashboard = dashboardService.canEditDashboard() and not app.isReadOnlyUser()
    $scope.isReadOnlyUser = app.isReadOnlyUser()
    $scope.areDashboardDividersAllowed = app.areDashboardDividersAllowed()
    $scope.isTouring = false
    $scope.showGrid = true

    # This event is triggered when creating a new chart or saving-as a chart
    $scope.$on('chartOrFigureAdded', (event, args) ->
      if $scope.isLoading # ignore event in this case; probably broadcasted because we added a chart through the chartBuilder route
        return
      DashboardItem.get
        clientId: app.getClientId()
        id: args.dcid
      , (dItem) ->
        #load the data
        loadedItems = dashboardItemLoadQueue.load([dItem])
        $scope.dashboardItems.push(loadedItems[0])
        #journal log for "create"
        _addNewDashboardItemsToGridster [dItem]
        _logDashboardItemAction(dItem, "create")
    )

    # This event is triggered when saving a chart via the chart builder
    $scope.$on('chartOrFigureSaved', (event, args) =>
      dashboardItemToLoad = _($scope.dashboardItems).find (dItem) ->
        return dItem.id is +args.dcid
      if dashboardItemToLoad?
        #load the data
        dashboardItemLoadQueue.load([dashboardItemToLoad], true)
        #journal log for "edit"
        _logDashboardItemAction(dashboardItemToLoad, "edit")
    )

    $scope.$on('dashboardReady', () ->
      $scope.dashboard = dashboardService.dashboard
    )

    $scope.$on('isTouring', (event, touringState) ->
      $scope.isTouring = touringState
    )

    $scope.$on('reloadWithStoreFilter', (event, storeFilter) ->
      $scope.dashboardItems = $scope.dashboardItems.map (dItem) ->
        # this is for putting the loading gif on the box
        if dItem.figure?
          delete dItem.figure.data
        dItem
      dashboardItemLoadQueue.load($scope.dashboardItems)
    )

    #watch for loading to be complete then get user events and see if we need to show the tour.
    if not app.isSupportUserSession()
      $scope.$watch "isLoading", (isLoading, old) ->
        if not isLoading
          $q.all([
            userEventService.getTourCompletedEvents(),
            userEventService.getTourSkippedEvents(),
          ]).then(([completedEvents, skippedEvents]) ->

            clearRandomPasswordWatcher = $scope.$watch(userHasRandomPassword, (userNeedsToResetPassword, oldValue) ->
              if not userNeedsToResetPassword
                clearRandomPasswordWatcher()

                if app.userHasImplementedClients()
                  # start a tour if the user hasn't completed or skipped one before
                  if completedEvents?.data?.length == skippedEvents?.data?.length == 0
                      dashboardService.startTourForFirstTime()
                  else
                    dashboardService.readyForCallToAction()

            , true)
          )

    $scope.removeDashboardItem = (event, did) ->
      event?.preventDefault()

      if !dashboardService.canEditDashboard()
        return

      #remove the dashboard item from the array and delete it using the resource fn $delete
      dItemIndex = null
      dItemToDelete = _($scope.dashboardItems).find (dItem, index) ->
        if dItem.id is did
          dItemIndex = index
          return true
        return false
      $scope.dashboardItems.splice(dItemIndex, 1)

      if dItemToDelete.divider?.id
        dividerIdToDelete = dItemToDelete.divider.id

      dItemToDelete.$delete(
        clientId: app.getClientId()
        id: did
      ).then () ->
        if dividerIdToDelete?
          DashboardDividers.delete($routeParams.dashId, dividerIdToDelete)
      .catch (error) ->
        notification.error("Dashboard Item Remove Error", "Failed to remove Dashboard Item. If error persists please contact support.", "global")
        $scope.dashboardItems.push(dItemToDelete)

    $scope.editChart = (event, chart, chartId) ->
      event?.preventDefault()

      if !dashboardService?.canEditDashboard() or app.isReadOnlyUser()
        return

      if !chart?
        Charts.getChartData(chartId).then (chart) ->
          _updateChartBuilderOptions(chart)
      else
        _updateChartBuilderOptions(chart)

    $scope.$on "closeChartBuilder", (event) =>
      $scope.chartBuilderOptions.chart = null
      $scope.chartBuilderOptions.isCreate = false
      $scope.chartBuilderOptions.trendId = 0
      $scope.showGrid = true

    $scope.chartBuilderOptions = {
      chart: null
      iscreate: false
      trendId: 0
      dashId: $routeParams.dashId
    }

    $scope.journalLogOpenChartDescription = (dashboardItem) ->
      start = new Date()
      idToLog = dashboardItem.chart?.id ? dashboardItem.figure?.id
      _journalLog('chart description popover opened', idToLog, (new Date() - start) / 1000)

    # Enlarge Dashboard Items functionality
    $scope.enlargedDashboardItem = null

    $scope.enlargeDashboardItem = (event, did) ->
      event?.preventDefault()
      window.scrollTo(0,0)
      $scope.enlargedDashboardItem = _.find($scope.dashboardItems, (dItem) ->
          dItem.id is did
      )

      $scope.showGrid = false

    $scope.closeEnlargeDashboardItem = () ->
      $scope.enlargedDashboardItem = null
      $scope.showGrid = true

    # Modals Logic

    $scope.dashboardItemSaveAsModal = (dashboardItem) ->
      if (not dashboardItem.chartId and not dashboardItem.figure) or $scope.dashboard.readonly
        return

      $modalScope = $scope.$new()
      $modalScope.isImport = $scope.dashboard?.is_syndicated

      if dashboardItem.figure?
        $modalScope.figure = dashboardItem.figure
        _createSaveAsModal($modalScope)
      else if dashboardItem.chartId?
        $modalScope.chart = dashboardItem.chart
        _createSaveAsModal($modalScope)

    _createSaveAsModal = (modalScope) ->
      modal = $modal(
        template: 'modal.chartSaveAs.html',
        show: true,
        backdrop: 'static'
        keyboard: false
        scope: modalScope
        modalClass: 'saveAsModal'
      )

      #this is here in order to get select2 to work in a modal
      modal.then( ->
        $('.saveAsModal').removeAttr("tabindex")
      )

    overdueBillingModalService.showModalIfOverdue($scope)

    # Determines whether or not a dashboard item can be exported
    $scope.canRawExport = (dashboardItem) ->
      unless app.canRawExport()
        return false

      if dashboardItem.figure? and dashboardItem.figure.reportQueryType is reportQueryType.SQL
        return false

      canRawExport = true

      if dashboardItem.chart?
        canRawExport = true
      else if dashboardItem.figure? and dashboardItem.figure.query?
        if figureService.containsGaMetric(dashboardItem.figure) or
          not figureService.isSingleSourceFigure(dashboardItem.figure)
            canRawExport = false
      else
        canRawExport = false

      return canRawExport

    $scope.rawExportModal = (dashboardItem) ->
      if !$scope.canRawExport(dashboardItem)
        return

      exportScope = $scope.$new()
      exportScope.dashboardItem = dashboardItem
      modal = $modal
        template: 'modal.rawExport.html'
        show: true
        backdrop: 'static'
        scope: exportScope
        trends: $scope.trends
        modalClass: 'rawExportsModal'

      #this is here in order to get select2 to work in a modal
       modal.then( ->
         $('.rawExportsModal').removeAttr("tabindex")
       )

    $rootScope.$on "reportRawExportQueued", () ->
      listUrl = appRoute("/settings/raw-export")
      notification.clear("global")
      notification.success(
        "Success.",
        "Raw export was successfully queued. Within manage data, the export can be viewed and downloaded from the <a href='#{listUrl}' target='_blank'>Raw Data Export List</a>.",
        "global",
        { dismissable: true, bindHtml: true }
      )

    _exportStoreFilterParam = () ->
      storeFilter = dashboardService.extraDashboardFilters?[0]?.value

      # Showing all stores so no need to add a filter
      unless storeFilter?
        return ""

      return "&store_id=#{encodeURIComponent(storeFilter)}"

    $scope.downloadCSV = (chartId, figureId, limitChoice) ->
      limitParam = if limitChoice? then "&limitChoice=#{limitChoice}" else ''

      if figureId?
        $window.open($url("/client/#{app.getClientId()}/figure/#{figureId}/export?format=csv#{limitParam}&dashboardId=#{$routeParams.dashId}#{_exportStoreFilterParam()}"), "_blank")
      else if chartId?
         $window.open($url("/client/" + app.getClientId() + "/chart/" + chartId + "/exportcsv/"), "_blank")
      return

    $scope.downloadXLSX = (chartId, figureId) ->
      if figureId?
        $window.open($url("/client/#{app.getClientId()}/figure/#{figureId}/export?format=xlsx&dashboardId=#{$routeParams.dashId}#{_exportStoreFilterParam()}"), "_blank")
      else if chartId?
        $window.open($url("/client/" + app.getClientId() + "/chart/" + chartId + "/exportxlsx/"), "_blank")
      return

    $scope.addNewReportClicked = (e) ->
      $rootScope.$broadcast "addNewReportClicked"
      e.stopPropagation()

    $scope.essentialsClient = app.getFeatureTier() is FEATURE_TIER.BASIC

    $scope.debug = null
    $scope.isSupportUser = app.isSupportUserSession()

    $scope.addDividerFromDashboard = (type, row, sizeY) ->
      if $scope.areDashboardDividersAllowed
        DashboardDividers.addDividerToDashboard(
          $routeParams.dashId
          app.getClientId()
          type
          row
          sizeY
        )

    $scope.addDashboardItemFromDivider = (report, row = 0, sizeY = 0) ->
      if app.hasFeatureFlag('RJQL_SERVICE_CLIENT')
        itemSettings =
          dashId: $routeParams.dashId
          figureId: report.id
          row: row + 1 + sizeY
          column: 1

        DashboardItem.save
          clientId: app.getClientId()
        , itemSettings
        , (dashboardItem) =>
          dashboardService.dashboardItemAdded dashboardItem

    $scope.updateDividerHeadingValue = (divider) ->
      if $scope.areDashboardDividersAllowed
        DashboardDividers.updateDividerHeadingValue(
          divider
          $routeParams.dashId
        )

    $scope.getAddFigureUrl = (row, sizeY) ->
      dashboardService.getAddFigureUrl(row, sizeY)

    init = () ->
      freeTrialBillingModalService.shouldShowModal().then (data) ->
        if data?.display
          modal = $modal
            template: 'modal.freeTrialBilling.html'
            show: true
            backdrop: 'static'
            scope: $scope.$new()
            keyboard: false

      if(app.hasFeatureFlag('RJQL_SERVICE_CLIENT'))
        Figures.getAllFigures().then (data) ->
          $scope.figuresList = data
      else
        $scope.figuresList = null

    # Directives should clean up after themselves
    _cleanUp = () ->
      # remove listeners
      gridsterResizedListener()
      return

    $scope.$on('$destroy', _cleanUp)

    init()
])
